module.exports = __webpack_public_path__ + "static/media/s_25.68558c19.mp3";